"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsxs, jsx } from 'react/jsx-runtime';
import { UNIFIED_DATA_MODELS } from '@membranehq/sdk';
import { ComboBox } from '../../ComboBox/ComboBox.mjs';
import '../../DataBuilderUI/FieldControlPanel/index.mjs';
import '../../DataBuilderUI/ActionBar.mjs';
import { Cell } from '../../DataBuilderUI/Cell.mjs';
import 'clsx';
import '../../DataBuilderUI/styles.module.css.mjs';
import { Row } from '../../DataBuilderUI/Row.mjs';
import '../../DataBuilderUI/Title.mjs';

function UdmSelect({ value, onChange }) {
  const options = [];
  for (const [key, udm] of Object.entries(UNIFIED_DATA_MODELS)) {
    options.push({
      label: udm.pluralName,
      value: key
    });
  }
  return /* @__PURE__ */ jsxs(Row, { children: [
    /* @__PURE__ */ jsx(Cell, { type: "name", children: "Data Model" }),
    /* @__PURE__ */ jsx(Cell, { type: "combobox", children: /* @__PURE__ */ jsx(ComboBox, { placeholder: "Select Universal Data Model", value, options, onChange }) })
  ] });
}

export { UdmSelect };
